<template>
  <div id="contenedor-listado-insumos-contrato-mobile">
    <v-list>
      <template v-for="frente in listado">
        <template>
          <v-list-item
            :key="frente.id">
            <v-list-item-action>
              {{ frente.orden }}
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ frente.descripcion }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-row>
                <v-btn icon @click="editar(frente)">
                  <v-icon >mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon @click="borrar(frente)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-row>
            </v-list-item-action>
          </v-list-item>
          <v-divider
            :key="`divider-${frente.id}`">
          </v-divider>
        </template>
      </template>
    </v-list>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'listadoInsumosContratoMobile',
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    editar(frente) {
      eventBus.$emit('editar-frente-contrato', frente);
    },
    borrar(frente) {
      eventBus.$emit('eliminar-frente-contrato', frente);
    },
  },
};
</script>

<style lang="scss">
</style>
